// extracted by mini-css-extract-plugin
module.exports = {"contentLang":"LanguageItems_contentLang__2O6VJ","active":"LanguageItems_active__3UqDn"};